import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid p-0 mt-3" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  class: "col-12 col-lg-3",
  "data-aos": "fade-right",
  "data-aos-offset": "300",
  "data-aos-delay": "150"
}
const _hoisted_4 = {
  class: "col-12 col-lg-9",
  "data-aos": "fade-up",
  "data-aos-offset": "300",
  "data-aos-delay": "150"
}
const _hoisted_5 = { class: "text-start text-primary m-2" }
const _hoisted_6 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "card-body text-start" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 3,
  class: "badge badge-primary bg-secondary ms-1 mb-2"
}
const _hoisted_13 = { class: "p-4" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-12 col-lg-3",
  "data-aos": "fade-right",
  "data-aos-offset": "300",
  "data-aos-delay": "150"
}, null, -1)
const _hoisted_16 = {
  class: "col-12 col-lg-9",
  "data-aos": "fade-up",
  "data-aos-offset": "300",
  "data-aos-delay": "150"
}
const _hoisted_17 = { class: "d-flex justify-content-between me-5" }
const _hoisted_18 = { class: "text-start text-primary m-2" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "fw-bold" }
const _hoisted_21 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_22 = {
  class: "card border border-0",
  style: {"width":"20rem"}
}
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "card-body text-start" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = {
  key: 3,
  class: "mt-1 text-secondary"
}
const _hoisted_29 = {
  key: 4,
  class: "mt-1 text-secondary"
}
const _hoisted_30 = {
  key: 5,
  class: "mt-1 text-secondary"
}
const _hoisted_31 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryItem = _resolveComponent("CategoryItem")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_CategoryItem)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.store.getters.localized('home04')), 1),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                class: "text-decoration-none card border border-0",
                style: {"width":"12rem"},
                to: `/product/${product._id}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "img-fluid p-3 rounded",
                    src: _ctx.imageUrl(product.images?.[0]?.path),
                    alt: "Card image cap",
                    style: {"aspect-ratio":"1/1"}
                  }, null, 8, _hoisted_7),
                  _createElementVNode("div", _hoisted_8, [
                    (_ctx.store.state.language==='th')
                      ? (_openBlock(), _createElementBlock("h5", _hoisted_9, _toDisplayString(product.nameTH), 1))
                      : (_ctx.store.state.language==='ch')
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_10, _toDisplayString(product.nameCH), 1))
                        : (_openBlock(), _createElementBlock("h5", _hoisted_11, _toDisplayString(product.nameEN), 1)),
                    (index === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "New"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 256))
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("h4", _hoisted_18, _toDisplayString(_ctx.store.getters.localized('blog')), 1),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_router_link, {
                class: "text-primary",
                to: "/blog"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.store.getters.localized('more')) + " >>", 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogs, (blog, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("img", {
                  class: "img-fluid p-3 rounded",
                  src: _ctx.imageUrl(blog.image),
                  alt: "Card image cap",
                  style: {"aspect-ratio":"1/1"}
                }, null, 8, _hoisted_23),
                _createElementVNode("div", _hoisted_24, [
                  (_ctx.store.state.language==='th')
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_25, _toDisplayString(blog.nameTH), 1))
                    : (_ctx.store.state.language==='ch')
                      ? (_openBlock(), _createElementBlock("h5", _hoisted_26, _toDisplayString(blog.nameCH), 1))
                      : (_openBlock(), _createElementBlock("h5", _hoisted_27, _toDisplayString(blog.nameEN), 1)),
                  (_ctx.store.state.language==='th')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(new Date (blog.createdAt).toThaiShort()), 1))
                    : (_ctx.store.state.language==='ch')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(new Date (blog.createdAt).toEngShort()), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(new Date (blog.createdAt).toEngShort()), 1)),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_router_link, {
                      class: "btn btn-secondary bg-secondary",
                      to: `/blog/${blog._id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.store.getters.localized('readMore')), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ])
              ]))
            }), 256))
          ])
        ])
      ])
    ])
  ], 64))
}